import baseAPI from '@/api/base';
import { EditZmanimDisplayOverride_N, GetZmanimDisplayOverride_N, RegisterZmanimDisplayOverride_N } from '@/dtos/zmanim_display_override_N.dto';
import {
  DELETE_ZMANIM_DISPLAY_OVERRIDE_N_URL,
  EDIT_ZMANIM_DISPLAY_OVERRIDE_N_URL,
  GET_ZMANIM_DISPLAY_OVERRIDE_N_URL,
  REGISTER_ZMANIM_DISPLAY_OVERRIDE_N_URL,
  TOGGLE_ZMANIM_DISPLAY_OVERRIDE_N_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class ZmanimDisplayOverride_N {
  static getZmanimDisplayOverrides_N = async (
    getZmanimDisplayOverride_N: GetZmanimDisplayOverride_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_ZMANIM_DISPLAY_OVERRIDE_N_URL, {
      params: getZmanimDisplayOverride_N,
    });
    return response;
  };

  static registerZmanimDisplayOverride_N = async (
    registerZmanimDisplayOverride_N: RegisterZmanimDisplayOverride_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_ZMANIM_DISPLAY_OVERRIDE_N_URL,
      { ...registerZmanimDisplayOverride_N }
    );
    return response;
  };

  static editZmanimDisplayOverride_N = async (
    editZmanimDisplayOverride_N: EditZmanimDisplayOverride_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_ZMANIM_DISPLAY_OVERRIDE_N_URL,
      { ...editZmanimDisplayOverride_N }
    );
    return response;
  };

  static toggleZmanimDisplayOverride_NIsActive = async (
    payload: Pick<EditZmanimDisplayOverride_N, 'id'> | EditZmanimDisplayOverride_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_ZMANIM_DISPLAY_OVERRIDE_N_IS_ACTIVE_URL,
      {
        ...payload,
      }
    );
    return response;
  };

  static deleteZmanimDisplayOverride_N = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_ZMANIM_DISPLAY_OVERRIDE_N_URL}/${id}`
    );
    return response;
  };
}

export default ZmanimDisplayOverride_N;
